// import React, { useState } from 'react';

// const PremiumFooter = () => {
//   const [email, setEmail] = useState('');

//   const handleNewsletterSubmit = (e) => {
//     e.preventDefault();
//     // Handle newsletter signup
//     console.log('Newsletter signup:', email);
//     setEmail('');
//   };

//   const services = [
//     { name: 'SEO & Marketing', href: '#seo' },
//     { name: 'Meta Advertising', href: '#meta' },
//     { name: 'Google Ads', href: '#google' },
//     { name: 'Graphic Design', href: '#design' },
//     { name: 'Web Development', href: '#development' }
//   ];

//   const quickLinks = [
//     { name: 'About Us', href: '#about' },
//     { name: 'Our Portfolio', href: '#portfolio' },
//     { name: 'Case Studies', href: '#cases' },
//     { name: 'Testimonials', href: '#testimonials' },
//     { name: 'Contact', href: '#contact' }
//   ];

//   const socialLinks = [
//     { 
//       name: 'Facebook', 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
//         </svg>
//       ), 
//       href: 'https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr', 
//       color: 'hover:text-blue-500' 
//     },
//     { 
//       name: 'Instagram',
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//       </svg>
//       ),
//       href: 'https://www.instagram.com/kanactify?igsh=MTcydGt2bDhuN2RkeQ%3D%3D&utm_source=qr',
//       color: 'hover:text-pink-500' 
//     },
//     { 
//       name: 'LinkedIn', 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
//         </svg>
//       ), 
//       href: '#linkedin', 
//       color: 'hover:text-blue-600' 
//     },
//     { 
//       name: 'Twitter', 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
//         </svg>
//       ), 
//       href: '#twitter', 
//       color: 'hover:text-blue-400' 
//     },
//     { 
//       name: 'YouTube', 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//         </svg>
//       ), 
//       href: 'https://youtube.com/@kanactify?si=vDpgpPRIJiRaDq23', 
//       color: 'hover:text-red-500' 
//     }
//   ];

//   return (
//     <footer className="relative bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 overflow-hidden">
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0">
//         <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse"></div>
//         <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse" style={{ animationDelay: '2s' }}></div>
//         <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-violet-500/10 to-purple-500/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-pulse" style={{ animationDelay: '4s' }}></div>
        
//         {/* Floating Elements */}
//         <div className="absolute top-20 left-20 w-2 h-2 bg-purple-400 rounded-full animate-float opacity-60"></div>
//         <div className="absolute top-40 right-32 w-1 h-1 bg-blue-400 rounded-full animate-float-delayed opacity-60"></div>
//         <div className="absolute bottom-32 left-1/4 w-1.5 h-1.5 bg-pink-400 rounded-full animate-float-slow opacity-60"></div>
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
//         {/* Newsletter Section */}
//         <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-12 border border-white/10 shadow-2xl mb-16 hover:bg-white/10 transition-all duration-500">
//           <div className="text-center">
//             <h3 className="text-3xl font-bold text-white mb-4 animate-shimmer">
//               🚀 Stay Ahead of Digital Trends
//             </h3>
//             <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
//               Subscribe to our newsletter for the latest insights on SEO, digital marketing, and business growth strategies.
//             </p>
//             <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Enter your email address"
//                 className="flex-1 px-6 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
//                 required
//               />
//               <button
//                 type="submit"
//                 className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-pink-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
//               >
//                 Subscribe
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Main Footer Content */}
//         <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12 mb-12">
//           {/* Company Info */}
//           <div className="lg:col-span-1">
//             <div className="flex items-center mb-6">
//               <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
//                 <span className="text-white font-bold text-xl">K</span>
//               </div>
//               <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
//                 Kanactify
//               </span>
//             </div>
//             <p className="text-gray-400 leading-relaxed mb-6">
//               Empowering businesses with cutting-edge digital marketing solutions. From SEO to social media, we help you grow your online presence and achieve measurable results.
//             </p>
//             <div className="flex space-x-4">
//               {socialLinks.map((social, index) => (
//                 <a
//                   key={index}
//                   href={social.href}
//                   className={`w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center text-gray-400 ${social.color} hover:bg-white/20 transition-all duration-300 transform hover:scale-110 hover:-translate-y-1`}
//                   aria-label={social.name}
//                 >
//                   {social.icon}
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* Services */}
//           <div>
//             <h4 className="text-white font-bold text-lg mb-6 flex items-center">
//               <span className="mr-2">🛠️</span>
//               Our Services
//             </h4>
//             <ul className="space-y-3">
//               {services.map((service, index) => (
//                 <li key={index}>
//                   <a
//                     href={service.href}
//                     className="text-gray-400 hover:text-purple-400 transition-colors duration-300 flex items-center group"
//                   >
//                     <span className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
//                     {service.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h4 className="text-white font-bold text-lg mb-6 flex items-center">
//               <span className="mr-2">🔗</span>
//               Quick Links
//             </h4>
//             <ul className="space-y-3">
//               {quickLinks.map((link, index) => (
//                 <li key={index}>
//                   <a
//                     href={link.href}
//                     className="text-gray-400 hover:text-purple-400 transition-colors duration-300 flex items-center group"
//                   >
//                     <span className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
//                     {link.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Contact Info */}
//           <div>
//             <h4 className="text-white font-bold text-lg mb-6 flex items-center">
//               <span className="mr-2">📞</span>
//               Get In Touch
//             </h4>
//             <div className="space-y-4">
//               <div className="flex items-start">
//                 <span className="text-purple-400 mr-3 mt-1">📧</span>
//                 <div>
//                   <p className="text-gray-400 text-sm">Email</p>
//                   <a href="mailto:hello@konnectify.com" className="text-white hover:text-purple-400 transition-colors duration-300">
//                     contact@kanactify.in
//                   </a>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <span className="text-purple-400 mr-3 mt-1">📱</span>
//                 <div>
//                   <p className="text-gray-400 text-sm">Phone</p>
//                   <a href="tel:+911234567890" className="text-white hover:text-purple-400 transition-colors duration-300">
//                     +91 9021076873
//                   </a>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <span className="text-purple-400 mr-3 mt-1">📍</span>
//                 <div>
//                   <p className="text-gray-400 text-sm">Location</p>
//                   <p className="text-white">
//                   333 sk mahathi, mathrusreenagar,miyapur, Hyd-500049
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom Bar */}
//         <div className="border-t border-white/10 pt-8">
//           <div className="flex flex-col md:flex-row justify-between items-center">
//             <div className="text-gray-400 text-sm mb-4 md:mb-0">
//               © 2025 Kanactify. All rights reserved. Made with ❤️ in India.
//             </div>
//             <div className="flex space-x-6 text-sm">
//               <a href="#privacy" className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
//                 Privacy Policy
//               </a>
//               <a href="#terms" className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
//                 Terms of Service
//               </a>
//               <a href="#cookies" className="text-gray-400 hover:text-purple-400 transition-colors duration-300">
//                 Cookie Policy
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0px); }
//           50% { transform: translateY(-10px); }
//         }
        
//         @keyframes float-delayed {
//           0%, 100% { transform: translateY(0px); }
//           50% { transform: translateY(-15px); }
//         }
        
//         @keyframes float-slow {
//           0%, 100% { transform: translateY(0px); }
//           50% { transform: translateY(-8px); }
//         }
        
//         @keyframes shimmer {
//           0%, 100% { background-position: 0% 50%; }
//           50% { background-position: 100% 50%; }
//         }
        
//         .animate-float { animation: float 6s ease-in-out infinite; }
//         .animate-float-delayed { animation: float-delayed 8s ease-in-out infinite; }
//         .animate-float-slow { animation: float-slow 10s ease-in-out infinite; }
//         .animate-shimmer { 
//           background: linear-gradient(45deg, #ffffff, #a855f7, #ec4899, #ffffff);
//           background-size: 300% 300%;
//           -webkit-background-clip: text;
//           background-clip: text;
//           animation: shimmer 3s ease infinite;
//         }
//       `}</style>
//     </footer>
//   );
// };

// export default PremiumFooter;

import React, { useState } from "react";

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@400;500;600;700&display=swap');
.ft-wrap{
  position:relative;
  background:linear-gradient(160deg,#0D0806 0%,#1A0D04 40%,#0D0806 100%);
  overflow:hidden;font-family:"DM Sans",sans-serif;
}
.ft-wrap *{box-sizing:border-box}
/* BG */
.ft-orb1{position:absolute;width:600px;height:600px;border-radius:50%;background:radial-gradient(circle,rgba(248,108,61,.1),transparent 70%);top:-200px;right:-150px;pointer-events:none;animation:ftob 8s ease-in-out infinite}
.ft-orb2{position:absolute;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(217,87,46,.07),transparent 70%);bottom:-100px;left:-80px;pointer-events:none;animation:ftob 10s ease-in-out infinite reverse}
.ft-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(248,108,61,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(248,108,61,.025) 1px,transparent 1px);background-size:56px 56px;pointer-events:none}
.ft-dots span{position:absolute;border-radius:50%;background:rgba(248,108,61,.4);animation:ftdot 6s ease-in-out infinite}
@keyframes ftob{0%,100%{transform:scale(1)}50%{transform:scale(1.1)}}
@keyframes ftdot{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
/* NEWSLETTER */
.ft-nl{
  position:relative;z-index:1;
  margin:0 auto;max-width:1280px;padding:80px 44px 0;
}
.ft-nl-card{
  border:1px solid rgba(248,108,61,.18);
  border-radius:28px;
  padding:60px 56px;
  background:rgba(255,255,255,.03);
  backdrop-filter:blur(12px);
  position:relative;overflow:hidden;
  box-shadow:0 0 0 1px rgba(248,108,61,.06) inset;
}
.ft-nl-card::before{content:"";position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent,#F86C3D,#FF8A5C,#F86C3D,transparent)}
.ft-nl-inner{max-width:560px;margin:0 auto;text-align:center}
.ft-nl-badge{display:inline-flex;align-items:center;gap:7px;background:rgba(248,108,61,.1);border:1px solid rgba(248,108,61,.22);border-radius:100px;padding:6px 16px;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#FF8A5C;margin-bottom:20px}
.ft-nl h3{font-family:"Playfair Display",serif;font-size:clamp(26px,3vw,38px);font-weight:900;color:#fff;line-height:1.15;margin-bottom:14px}
.ft-nl p{font-size:15px;color:rgba(255,200,160,.5);line-height:1.75;margin-bottom:36px}
.ft-nl-form{display:flex;gap:12px}
.ft-nl-input{
  flex:1;padding:14px 20px;
  background:rgba(255,255,255,.05);
  border:1.5px solid rgba(248,108,61,.18);
  border-radius:14px;
  color:#fff;font-family:"DM Sans",sans-serif;font-size:14px;
  outline:none;transition:border-color .25s,box-shadow .25s;
}
.ft-nl-input::placeholder{color:rgba(255,200,160,.3)}
.ft-nl-input:focus{border-color:#F86C3D;box-shadow:0 0 0 4px rgba(248,108,61,.1)}
.ft-nl-btn{
  padding:14px 28px;border-radius:14px;
  background:linear-gradient(135deg,#F86C3D,#D9572E);
  color:#fff;font-family:"DM Sans",sans-serif;
  font-size:14px;font-weight:700;border:none;cursor:pointer;
  box-shadow:0 6px 24px rgba(248,108,61,.35);
  white-space:nowrap;
  transition:transform .25s cubic-bezier(.34,1.56,.64,1),box-shadow .25s;
}
.ft-nl-btn:hover{transform:translateY(-3px);box-shadow:0 12px 36px rgba(248,108,61,.5)}
/* MAIN GRID */
.ft-main{position:relative;z-index:1;max-width:1280px;margin:0 auto;padding:80px 44px;display:grid;grid-template-columns:1.8fr 1fr 1fr 1.4fr;gap:56px}
/* BRAND COL */
.ft-brand-logo{display:flex;align-items:center;gap:10px;margin-bottom:18px}
.ft-logo-icon{width:44px;height:44px;border-radius:12px;background:linear-gradient(135deg,#F86C3D,#D9572E);display:flex;align-items:center;justify-content:center;font-family:"Playfair Display",serif;font-size:20px;font-weight:900;color:#fff;box-shadow:0 6px 20px rgba(248,108,61,.35)}
.ft-logo-txt{font-family:"DM Sans",sans-serif;font-size:20px;font-weight:800;color:#fff}
.ft-logo-txt span{color:#F86C3D}
.ft-brand-desc{font-size:14px;color:rgba(255,200,160,.45);line-height:1.8;margin-bottom:28px}
.ft-socials{display:flex;gap:10px}
.ft-soc{
  width:38px;height:38px;border-radius:10px;
  background:rgba(248,108,61,.06);
  border:1.5px solid rgba(248,108,61,.12);
  display:flex;align-items:center;justify-content:center;
  transition:all .25s cubic-bezier(.34,1.56,.64,1);cursor:pointer;
}
.ft-soc:hover{background:linear-gradient(135deg,#F86C3D,#D9572E);border-color:transparent;transform:scale(1.15) translateY(-2px);box-shadow:0 8px 24px rgba(248,108,61,.4)}
.ft-soc:hover svg{fill:#fff}
.ft-soc svg{width:16px;height:16px;fill:#F86C3D;transition:fill .2s}
/* LINK COLS */
.ft-col-title{font-family:"Playfair Display",serif;font-size:15px;font-weight:700;color:#fff;margin-bottom:22px;display:flex;align-items:center;gap:8px}
.ft-col-title::after{content:"";flex:1;height:1px;background:linear-gradient(90deg,rgba(248,108,61,.3),transparent)}
.ft-links{display:flex;flex-direction:column;gap:11px}
.ft-links a{font-size:13px;color:rgba(255,200,160,.45);text-decoration:none;display:flex;align-items:center;gap:0;transition:color .2s,gap .2s}
.ft-links a::before{content:"→";opacity:0;font-size:12px;transition:opacity .2s,margin .2s;margin-right:0;color:#F86C3D}
.ft-links a:hover{color:#FF8A5C}
.ft-links a:hover::before{opacity:1;margin-right:7px}
/* CONTACT COL */
.ft-contact-item{display:flex;align-items:flex-start;gap:12px;margin-bottom:18px}
.ft-contact-icon{width:34px;height:34px;border-radius:9px;background:rgba(248,108,61,.1);border:1px solid rgba(248,108,61,.18);display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0}
.ft-contact-lbl{font-size:11px;color:rgba(255,200,160,.35);font-weight:600;letter-spacing:.5px;text-transform:uppercase;margin-bottom:2px}
.ft-contact-val{font-size:13px;color:rgba(255,200,160,.7);font-weight:500}
.ft-contact-val a{color:rgba(255,200,160,.7);text-decoration:none;transition:color .2s}
.ft-contact-val a:hover{color:#F86C3D}
/* BOTTOM */
.ft-bottom{position:relative;z-index:1;max-width:1280px;margin:0 auto;padding:24px 44px;border-top:1px solid rgba(248,108,61,.1);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:16px}
.ft-copy{font-size:12px;color:rgba(255,200,160,.28);font-weight:500}
.ft-copy span{color:rgba(248,108,61,.6)}
.ft-policy{display:flex;gap:24px}
.ft-policy a{font-size:12px;color:rgba(255,200,160,.3);text-decoration:none;transition:color .2s}
.ft-policy a:hover{color:#F86C3D}
/* BADGE ROW */
.ft-badges{display:flex;gap:12px;flex-wrap:wrap;margin-top:4px}
.ft-badge{padding:5px 14px;border-radius:100px;background:rgba(248,108,61,.07);border:1px solid rgba(248,108,61,.15);font-size:11px;font-weight:700;color:rgba(248,108,61,.7);letter-spacing:.5px;text-transform:uppercase}
/* RESPONSIVE */
@media(max-width:1100px){.ft-main{grid-template-columns:1fr 1fr;gap:36px}}
@media(max-width:768px){
  .ft-nl-card{padding:40px 28px}
  .ft-nl-form{flex-direction:column}
  .ft-nl{padding:60px 24px 0}
  .ft-main{grid-template-columns:1fr;padding:60px 24px;gap:40px}
  .ft-bottom{padding:20px 24px}
}
`;

const SOCIAL = [
  {href:"https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr",d:<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>},
  {href:"https://www.instagram.com/kanactify?igsh=MTcydGt2bDhuN2RkeQ%3D%3D&utm_source=qr",d:<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>},
  {href:"https://youtube.com/@kanactify?si=vDpgpPRIJiRaDq23",d:<path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>},
  {href:"#linkedin",d:<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>},
];

const SERVICES=[
  {n:"Social Media Marketing",h:"#services"},
  {n:"Lead Generation",h:"#services"},
  {n:"Google Ads",h:"#services"},
  {n:"Meta Advertising",h:"#services"},
  {n:"Corporate Branding",h:"#services"},
  {n:"Web Design",h:"#services"},
];

const LINKS=[
  {n:"About Us",h:"#about"},
  {n:"Case Studies",h:"#stories"},
  {n:"Our Clients",h:"#clients"},
  {n:"Instagram Pages",h:"#stories"},
  {n:"Contact Us",h:"#contact"},
];

const PremiumFooter = () => {
  const [email, setEmail] = useState("");
  const [nlOk, setNlOk] = useState(false);

  const nlSubmit = e => {
    e.preventDefault();
    setNlOk(true);
    setEmail("");
    setTimeout(() => setNlOk(false), 4000);
  };

  return (
    <>
      <style>{CSS}</style>
      <footer className="ft-wrap">
        <div className="ft-orb1"/><div className="ft-orb2"/><div className="ft-grid"/>
        <div className="ft-dots">
          <span style={{width:"4px",height:"4px",top:"15%",left:"8%",animationDelay:"0s"}}/>
          <span style={{width:"3px",height:"3px",top:"40%",right:"10%",animationDelay:"2s"}}/>
          <span style={{width:"5px",height:"5px",bottom:"25%",left:"25%",animationDelay:"4s"}}/>
        </div>

        {/* NEWSLETTER */}
        <div className="ft-nl">
          <div className="ft-nl-card">
            <div className="ft-nl-inner">
              <div className="ft-nl-badge">✦ Newsletter</div>
              <h3>Stay Ahead of<br/><span style={{background:"linear-gradient(135deg,#F86C3D,#FF8A5C)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>Digital Trends</span></h3>
              <p>Get the latest insights on digital marketing, lead generation and brand growth — straight to your inbox.</p>
              {nlOk && <div style={{marginBottom:"16px",padding:"12px 18px",background:"rgba(34,197,94,.08)",border:"1px solid rgba(34,197,94,.22)",borderRadius:"12px",fontSize:"14px",fontWeight:600,color:"#16a34a",textAlign:"center"}}>✅ Subscribed! Welcome to the family.</div>}
              <form className="ft-nl-form" onSubmit={nlSubmit}>
                <input className="ft-nl-input" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="Enter your email address" required/>
                <button className="ft-nl-btn" type="submit">Subscribe →</button>
              </form>
            </div>
          </div>
        </div>

        {/* MAIN GRID */}
        <div className="ft-main">
          {/* BRAND */}
          <div>
            <div className="ft-brand-logo">
              <div className="ft-logo-icon">K</div>
              <div className="ft-logo-txt">Kan<span>actify</span></div>
            </div>
            <p className="ft-brand-desc">Hyderabad's most trusted digital marketing agency. We turn brands into lead generation machines through strategy, creativity and data-driven campaigns.</p>
            <div className="ft-badges">
              <span className="ft-badge">Est. 2018</span>
              <span className="ft-badge">Hyderabad</span>
              <span className="ft-badge">200+ Brands</span>
            </div>
            <div className="ft-socials" style={{marginTop:"20px"}}>
              {SOCIAL.map((s,i)=>(
                <a key={i} href={s.href} target="_blank" rel="noreferrer" className="ft-soc">
                  <svg viewBox="0 0 24 24">{s.d}</svg>
                </a>
              ))}
            </div>
          </div>

          {/* SERVICES */}
          <div>
            <div className="ft-col-title">Services</div>
            <div className="ft-links">
              {SERVICES.map((s,i)=><a key={i} href={s.h}>{s.n}</a>)}
            </div>
          </div>

          {/* LINKS */}
          <div>
            <div className="ft-col-title">Company</div>
            <div className="ft-links">
              {LINKS.map((l,i)=><a key={i} href={l.h}>{l.n}</a>)}
            </div>
          </div>

          {/* CONTACT */}
          <div>
            <div className="ft-col-title">Contact</div>
            {[
              {icon:"📧",lbl:"Email",val:<a href="mailto:contact@kanactify.in">contact@kanactify.in</a>},
              {icon:"📞",lbl:"Phone",val:<a href="tel:+919021076873">+91 9021076873</a>},
              {icon:"📍",lbl:"Address",val:"333 SK Mahathi, Mathrusreenagar, Miyapur, Hyd-500049"},
              {icon:"⏰",lbl:"Working Hours",val:"Mon–Sat: 9 AM – 7 PM IST"},
            ].map((c,i)=>(
              <div key={i} className="ft-contact-item">
                <div className="ft-contact-icon">{c.icon}</div>
                <div><div className="ft-contact-lbl">{c.lbl}</div><div className="ft-contact-val">{c.val}</div></div>
              </div>
            ))}
          </div>
        </div>

        {/* BOTTOM */}
        <div className="ft-bottom">
          <div className="ft-copy">© 2025 <span>Kanactify</span>. All rights reserved. Made with ❤️ in Hyderabad, India.</div>
          <div className="ft-policy">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
            <a href="#cookies">Cookie Policy</a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default PremiumFooter;